import { render, staticRenderFns } from "./Wp_tb_select_base.vue?vue&type=template&id=be1cfb7a&scoped=true&"
import script from "./Wp_tb_select_base.vue?vue&type=script&lang=js&"
export * from "./Wp_tb_select_base.vue?vue&type=script&lang=js&"
import style0 from "./Wp_tb_select_base.vue?vue&type=style&index=0&id=be1cfb7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1cfb7a",
  null
  
)

export default component.exports